<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        Debitur Information
        <div class="card-header-actions">
          <!-- <button class="btn btn-primary mr-1" @click="testPrint()">
            <i class="fa fa-print"></i> Test Print
          </button> -->
          <button class="btn btn-primary mr-1" @click="printPDFDebiturInfo">
            <i class="fa fa-print"></i> Print Debitur Info
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="12">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input readonly v-model="model.no_kontrak" @keyup.13.native="lkuPinjamanShow = true"
                  :state="!$v.frmdt.pinjamankey.$error" style="max-width:225px;"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl. Perhitungan</label>
                </b-input-group-prepend>
                <b-form-input type="date" v-model="frmdt.tglpelunasan" :state="!$v.frmdt.tglpelunasan.$error"
                  class="mr-2"></b-form-input>
                <!-- :min="new Date | moment('YYYY-MM-DD')" -->
                <b-button variant="danger" v-b-tooltip.hover title="Hitung biaya pelunasan" @click="calculate">
                  <i class="fa fa-calculator"></i> Calc.
                </b-button>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-table-simple responsive bordered>
        <b-tbody>
          <b-tr>
            <b-td sticky-column>Nama Debitur</b-td>
            <b-td colspan="3">{{ frmdt.CustName }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>No. CIF</b-td>
            <b-td colspan="3">{{ frmdt.CustCode }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>No. Kontrak</b-td>
            <b-td colspan="3">{{ frmdt.no_kontrak }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>No. Agreement</b-td>
            <b-td colspan="3">{{ frmdt.no_agreement }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Model Pinjaman</b-td>
            <b-td colspan="3">{{ frmdt.model_pinjaman }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Lokasi</b-td>
            <b-td>{{ frmdt.lokasiLDSK1 }}</b-td>
            <b-td colspan="2">{{ frmdt.lokasiLDSK2 }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Suku Bunga | Tenor</b-td>
            <b-td class="text-right">{{ frmdt.bunga_tarifthn | numFormat('0,0.00') }}%</b-td>
            <b-td class="text-right">{{ frmdt.tenor }}</b-td>
            <b-td class="text-center">Bulan</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Open Date | Maturity Date</b-td>
            <b-td class="text-right">{{ frmdt.startdate | moment('DD-MMM-YY') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.duedate | moment('DD-MMM-YY') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Cessie</b-td>
            <b-td></b-td>
            <b-td class="text-center" colspan="2">{{ frmdt.cessie_date | moment('DD-MMM-YY') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Plafon Awal</b-td>
            <b-td colspan="3" class="text-right">{{ frmdt.plafond | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Angsuran</b-td>
            <b-td colspan="3" class="text-right">{{ frmdt.installment_amount | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>OS Pokok Belum Jatuh Tempo</b-td>
            <b-td class="text-right">{{ frmdt.os_pokok_blm_jt | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.os_pokok_blm_jt | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Tunggakan Angsuran</b-td>
            <b-td class="text-right">{{ frmdt.ttlangsuran | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.ttlangsuran | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Bunga Berjalan</b-td>
            <b-td class="text-right">{{ frmdt.ttlinterest | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.ttlinterest | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Denda Angsuran</b-td>
            <b-td class="text-right">{{ frmdt.ttllatecharge | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.ttllatecharge | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>Denda Lainnya</b-td>
            <b-td class="text-right">{{ frmdt.dendalain | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.dendalain | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-td sticky-column>{{ this.frmdt.pinalty_rate }}% Pinalty</b-td>
            <b-td class="text-right">{{ frmdt.pinalty | numFormat('0,0.00') }}</b-td>
            <b-td class="text-right" colspan="2">{{ frmdt.pinalty | numFormat('0,0.00') }}</b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>Total Kewajiban</b-th>
            <b-td class="text-right" colspan="3"><b>{{ frmdt.ttlpayment_awal | numFormat('0,0.00') }}</b></b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>Pembulatan</b-th>
            <b-td class="text-right" colspan="3"><b>{{ frmdt.paypembulatan | numFormat('0,0.00') }}</b></b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column># Fasilitas Pinjaman Debitur</b-th>
            <b-td class="text-right" colspan="3"><b></b></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <table border="0" style="width:100%">
        <tr>
          <td style="width:30%;"><span class="ml-2">Total OS Pokok</span></td>
          <td>: <b class="ml-4">{{ frmdt.OS_Principal_Amount ? frmdt.OS_Principal_Amount : "" | numFormat('0,0.00') }}</b>
          </td>
        </tr>
        <tr>
          <td style="width:30%;"><span class="ml-2">Prepaid</span></td>
          <td>: <b class="ml-4">{{ frmdt.prepaid ? frmdt.prepaid : "" | numFormat('0,0.00') }}</b></td>
        </tr>
        <tr>
          <td style="width:30%;"><span class="ml-2">* Data dihitung sampai dengan</span></td>
          <td>: <label class="ml-4">{{ frmdt.tglpelunasan | moment('DD MMM YYYY') }}</label></td>
        </tr>
        <tr>
          <td style="width:30%;"><span class="ml-2">{{ label.vanumber }}</span></td>
          <td>
            <b-form-input v-if="user.role_name!='user'" v-model="frmdt.vanumber"></b-form-input>
            <span v-else>:<b class="ml-4">{{ frmdt.vanumber }}</b> </span>
          </td>
        </tr>
        <tr>
          <td style="width:30%;"><span class="ml-2">Nama Bank</span></td>
          <td>
            <b-form-input v-if="user.role_name!='user'" v-model="frmdt.namabank"></b-form-input>
            <span v-else>:<b class="ml-4">{{ frmdt.namabank }}</b> </span>
          </td>
        </tr>
        <tr>
          <td style="width:30%;"><span class="ml-2">Berita</span></td>
          <td v-if="frmdt.CustName">: <b class="ml-4">Pinjaman an. {{ frmdt.CustName }}</b></td>
          <td v-else>: </td>
        </tr>
        <tr>
          <th style="width:30%;"><span class="ml-2"></span></th>
          <td v-if="frmdt.CustName">&nbsp;&nbsp;<b class="ml-4">No. rekening pinjaman {{ frmdt.no_kontrak }}</b></td>
        </tr>
      </table>

    </b-card>
    <b-modal v-model="lkuPinjamanShow" size="lg" :hide-footer="true" title="Daftar Pinjaman" :centered="true">
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      pinjamankey: { required },
      //tglmulaipelunasan: { required },
      tglpelunasan: { required },
      // tglsurat: { required },
      // nosurat: { required },
      // kepada: { required },
      // perihal: { required },
      // kronologis: {
      //   required: requiredIf(function () {
      //     return this.canSave;
      //   }),
      //  },
      // cc: {
      //   required: requiredIf(function () {
      //     return this.canSave;
      //   }),
      //  },
      // ttd1_diajukan_nama: { required },
      // ttd1_diajukan_jabatan: { required },
      // ttd1_mengetahui_nama: { required },
      // ttd1_mengetahui_jabatan: { required },
      // ttd1_disetujui_nama: { required },
      // ttd1_disetujui_jabatan: { required },
    },
  },
  data() {
    return {
      showReport: false,
      reportUrl: null,
      isLoading: false,
      text: "",
      isBusy: false,
      isPelunasankey: false,
      model: {},
      frmdt: {
        statussp: null,
        pinjamankey: "",
        tglmulaipelunasan: moment().format("YYYY-MM-DD"),
        tglpelunasan: moment().format("YYYY-MM-DD"),
        hariini: moment().format("YYYY-MM-DD"),
        //
        tglsurat: moment().format("YYYY-MM-DD"),
        nosurat: "",
        kepada: "Komite Kredit",
        perihal: "Persetujuan Pelunasan Dipercepat",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        kronologis: "",
        cc: "- Loan Admin \n- Audit",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        // uraian: "",
        ttlinstalmentcurrent: 0,
        ttllatechargecurrent: 0,
        ttlprincipalcurrent: 0,
        ttlinterestcurrent: 0,
        ttlinstalment: 0,
        ttlprincipal: 0,
        ttllatecharge: 0,
        ttlinterest: 0,
        ttlangsuran: 0,
        ospokokbelumjt: 0,
        dendalain: 0,
        pinalty: 0,
        pinalty_rate: 8, //default 8% pinalty
        // diskon_percent: 0,
        // diskon_amount: 0,

        diskon_principal_percent: 0,
        diskon_principal_amount: 0,
        diskon_interest_percent: 0,
        diskon_interest_amount: 0,

        diskon_angsuran_percent: 0,
        diskon_angsuran_amount: 0,

        diskon_latecharge_percent: 0,
        diskon_latecharge_amount: 0,

        diskon_ospokokbelumjt_percent: 0,
        diskon_ospokokbelumjt_amount: 0,
        diskon_dendalain_percent: 0,
        diskon_dendalain_amount: 0,
        diskon_pinalty_percent: 0,
        diskon_pinalty_amount: 0,

        net_ttlprincipal: 0,
        net_ttlinterest: 0,

        net_ttlangsuran: 0,

        net_ttllatecharge: 0,

        net_ospokokbelumjt: 0,
        net_dendalain: 0,
        net_pinalty: 0,

        ttlpayment_awal: 0,
        ttlpayment_diskon: 0,
        ttlpayment: 0,
        prepaid: 0,
        ttlmustpay: 0,
        tipepelunasan: "Normal",
        paypembulatan: 0,
        sisapembayaran: 0,
        pjxcode:''
      },
      label: {
        vanumber: 'Nomor Virtual Account'
      },
      ifCalculated: false,
      stateTtlPay: true,
      lkuPinjamanShow: false,
      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      return this.$v.frmdt.$invalid;
    },
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    "frmdt.net_ospokokbelumjt"(val) {
      const diskon_ospokokbelumjt_amount = this.frmdt.ospokokbelumjt - val;
      this.frmdt.diskon_ospokokbelumjt_amount = diskon_ospokokbelumjt_amount
      this.calcpaymn();
    },
    "frmdt.net_ttlangsuran"(val) {
      const diskon_angsuran_amount = this.frmdt.ttlangsuran - val;
      this.frmdt.diskon_angsuran_amount = diskon_angsuran_amount
      this.calcpaymn();
    },
    "frmdt.net_ttlinterest"(val) {
      const diskon_interest_amount = this.frmdt.ttlinterest - val;
      this.frmdt.diskon_interest_amount = diskon_interest_amount
      this.calcpaymn();
    },
    "frmdt.net_ttllatecharge"(val) {
      const diskon_latecharge_amount = this.frmdt.ttllatecharge - val;
      this.frmdt.diskon_latecharge_amount = diskon_latecharge_amount
      this.calcpaymn();
    },
    "frmdt.net_dendalain"(val) {
      const diskon_dendalain_amount = this.frmdt.dendalain - val;
      this.frmdt.diskon_dendalain_amount = diskon_dendalain_amount
      this.calcpaymn();
    },
    "frmdt.net_pinalty"(val) {
      const diskon_pinalty_amount = this.frmdt.pinalty - val;
      this.frmdt.diskon_pinalty_amount = diskon_pinalty_amount
      this.calcpaymn();
    },
  },
  created: async function () {
    this.model.model_pinjaman = "PAB";
    if (this.$route.params.pelunasankey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await pelunasan.detail(this.$route.params.pelunasankey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }

        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.tglpelunasan = this.frmdt.tglpelunasan
          ? moment(this.frmdt.tglpelunasan).format("YYYY-MM-DD")
          : "";
        this.frmdt.tglmulaipelunasan = this.frmdt.tglmulaipelunasan
          ? moment(this.frmdt.tglmulaipelunasan).format("YYYY-MM-DD")
          : "";

        this.frmdt.tglsurat = this.frmdt.tglsurat
          ? moment(this.frmdt.tglsurat).format("YYYY-MM-DD")
          : "";

        this.frmdt.tipepelunasan = res.tipepelunasan;


        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
    this.frmdt.ttd1_diajukan_nama = this.model.ttd1_diajukan_nama ? this.model.ttd1_diajukan_nama : this.$store.state.user.full_name; //Diajukan Oleh
    this.frmdt.ttd1_diajukan_jabatan = this.model.ttd1_diajukan_jabatan ? this.model.ttd1_diajukan_jabatan : this.$store.state.user.jabatan; //Diajukan Oleh
    const dataWF = await pelunasan.getworkflow();
    this.frmdt.ttd1_mengetahui_nama = this.model.ttd1_mengetahui_nama ? this.model.ttd1_mengetahui_nama : dataWF[0].full_name; //Mengetahui
    this.frmdt.ttd1_mengetahui_jabatan = this.model.ttd1_mengetahui_jabatan ? this.model.ttd1_mengetahui_jabatan : dataWF[0].jabatan; //Mengetahui
    this.frmdt.ttd1_disetujui_nama = this.model.ttd1_disetujui_nama ? this.model.ttd1_disetujui_nama : dataWF[1].full_name; //Disetujui Oleh
    this.frmdt.ttd1_disetujui_jabatan = this.model.ttd1_disetujui_jabatan ? this.model.ttd1_disetujui_jabatan : dataWF[1].jabatan; //Disetujui Oleh
  },
  methods: {
    async onSelectLkuPinjaman(_selected) {
      this.resetCalc();
      this.frmdt.pinjamankey = _selected.pinjamankey;
      this.frmdt.nasabahkey = _selected.nasabahkey;
      this.frmdt.pinalty_rate = _selected.pinalty_rate ? _selected.pinalty_rate : "8"; //default 8% pinalty

      for (const key in _selected) {
        this.frmdt[key] = _selected[key];
        this.model[key] = _selected[key];
      }

      this.frmdt.lokasiLDSK1 = _selected.branch;
      this.frmdt.lokasiLDSK2 = _selected.LDSK;
      this.frmdt.cessie_date = _selected.cessie_date;
      this.frmdt.namabank = _selected.namabank2;
      this.model.namabank = _selected.namabank2;

      this.lkuPinjamanShow = false;
    },
    async calculate() {
      try {
        if (this.invalidFrmDt) {
          // console.log("validation : ", this.$v.issuedLinesObj);
          // console.log("model obj : ", this.issuedLinesObj);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.isLoading = true;
          const data = await pinjaman.calcpelunasan(this.frmdt);
          const today = moment();
          const tglpelunasan = moment(this.frmdt.tglpelunasan);
          let diffDays = tglpelunasan.diff(today, "days");

          const {
            model_pinjaman,
            principal: pjmPrincipal,
            duedate: ODdate,
            bungaod_tarifthn,
            bunga_tarifthn,
          } = this.model;
          const { bbnPinjamanCurr, bbnPinjamanPelunasan } = data;
          // START total beban sampai hari ini
          this.frmdt.ttlinstalmentcurrent = bbnPinjamanCurr.ttlangsuran;
          this.frmdt.ttlprincipalcurrent = bbnPinjamanCurr.OS_Principal_Amount;
          this.frmdt.ttlinterestcurrent = bbnPinjamanCurr.OS_Interest_Amount;
          this.frmdt.ttllatechargecurrent = bbnPinjamanCurr.ttllatecharge;
          this.frmdt.cessie_etm = bbnPinjamanCurr.cessie_etm;
          this.frmdt.ttlosprincipal_untilmaturity = bbnPinjamanPelunasan.OS_Principal_Amount;

          // END

          // if (model_pinjaman == "PRK") {
          //   // current
          //   this.frmdt.ttlprincipalcurrent = pjmPrincipal;
          //   this.frmdt.ttlinterestcurrent =
          //     bbnPinjamanCurr.sum_bungahrian_interest;
          //   // sampai pelunasan
          //   this.frmdt.ttlprincipal = pjmPrincipal;
          //   this.frmdt.ttlinterest =
          //     bbnPinjamanPelunasan.sum_bungahrian_interest;

          //   this.frmdt.ttlangsuran = this.frmdt.ttlangsuran ?
          //     this.frmdt.ttlprincipal + this.frmdt.ttlinterest
          //     : 0;
          //   this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
          //   this.frmdt.dendalain = 0; //tanyakan kembali dendalain
          //   this.frmdt.pinalty = 0; //tanyakan kembali pinalty

          //   if (diffDays > 0) {
          //     diffDays += 1;
          //     let diffODDays = today.diff(moment(ODdate), "days");
          //     let ifOverDue = diffODDays > 0 ? true : false;
          //     const interestPrcnt = ifOverDue
          //       ? bungaod_tarifthn
          //       : bunga_tarifthn;
          //     const interest =
          //       pjmPrincipal * (interestPrcnt / 100 / 360) * diffDays;
          //     this.frmdt.ttlinterest += interest;
          //   }
          // }

          if (model_pinjaman == "PAB" || model_pinjaman == "PB" || model_pinjaman == "PRK") {
            // START total beban sampai tanggal pelunasan
            this.frmdt.ttlinstalment =
              bbnPinjamanPelunasan.sum_angsrn_installment;
            this.frmdt.ttlprincipal = bbnPinjamanPelunasan.sum_angsrn_principal;

            this.frmdt.ttllatecharge =
              bbnPinjamanPelunasan.sum_nilai_dendahrian;
            this.frmdt.ttlinterest = bbnPinjamanPelunasan.sum_angsrn_interest;

            this.frmdt.ttlangsuran = this.frmdt.ttlangsuran ?
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest
              : 0;
            //console.log("#this.frmdt.ttlangsuran: ", this.frmdt.ttlangsuran);
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = bbnPinjamanPelunasan.dendalain;//tanyakan kembali dendalain
            this.frmdt.pinalty = 0; //tanyakan kembali pinalty

            // END

            // START HITUNG ULANG DENDA SAMPAI TANGGAL PELUNASAN
            if (diffDays > 0) {
              diffDays += 1;
              const ttlDendaSmpaiLns =
                diffDays *
                (bbnPinjamanCurr.sum_angsrn_principal *
                  (this.model.denda_tarifhri / 100));
              this.frmdt.ttllatecharge += ttlDendaSmpaiLns;
            }
            // END
          }

          for (const key in bbnPinjamanPelunasan) {
            this.frmdt[key] = bbnPinjamanPelunasan[key];
          }
          //console.log("#this.frmdt 1: ", this.frmdt);
          //console.log("#1 this.frmdt.ttlangsuran: ", this.frmdt.ttlangsuran);
          this.calcpaymn();
          this.ifCalculated = true;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    calcpaymn() {

      this.frmdt.net_ospokokbelumjt =
        (this.frmdt.ospokokbelumjt || 0) -
        this.frmdt.diskon_ospokokbelumjt_amount;

      this.frmdt.net_ttlprincipal =
        (this.frmdt.ttlprincipal || 0) - this.frmdt.diskon_principal_amount;

      this.frmdt.net_ttlinterest =
        (this.frmdt.ttlinterest || 0) - this.frmdt.diskon_interest_amount;

      this.frmdt.net_ttlangsuran =
        (this.frmdt.ttlangsuran || 0) - this.frmdt.diskon_angsuran_amount;

      this.frmdt.net_ttllatecharge =
        (this.frmdt.ttllatecharge || 0) - this.frmdt.diskon_latecharge_amount;

      this.frmdt.net_dendalain =
        (this.frmdt.dendalain || 0) - this.frmdt.diskon_dendalain_amount;
      this.frmdt.net_pinalty =
        (this.frmdt.pinalty || 0) - this.frmdt.diskon_pinalty_amount;

      this.frmdt.ttlpayment =
        this.frmdt.net_ttlangsuran +
        this.frmdt.net_ttlinterest +
        this.frmdt.net_ttllatecharge +
        this.frmdt.net_ospokokbelumjt +
        this.frmdt.net_dendalain +
        this.frmdt.net_pinalty;

      this.frmdt.ttlpayment_awal =
        (this.frmdt.ttlangsuran || 0) +
        (this.frmdt.ttlinterest || 0) +
        (this.frmdt.ttllatecharge || 0) +
        (this.frmdt.ospokokbelumjt || 0) +
        (this.frmdt.dendalain || 0) +
        (this.frmdt.pinalty || 0);

      this.frmdt.ttlpayment_diskon =
        (this.frmdt.diskon_angsuran_amount || 0) +
        (this.frmdt.diskon_interest_amount || 0) +
        (this.frmdt.diskon_latecharge_amount || 0) +
        (this.frmdt.diskon_ospokokbelumjt_amount || 0) +
        (this.frmdt.diskon_dendalain_amount || 0) +
        (this.frmdt.diskon_pinalty_amount || 0);

      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
      const ttlpayment_awal = this.frmdt.ttlpayment_awal / 1000;
      this.frmdt.paypembulatan = Math.round(ttlpayment_awal) * 1000;
      this.frmdt.ttlangsuran = this.frmdt.ttlangsuran ? this.frmdt.ttlangsuran : 0;

      this.frmdt.sisapembayaran = this.frmdt.OS_Principal_Amount - this.frmdt.prepaid
      // if (this.frmdt.pjxcode == "BTPN2023") {
      //   if (this.frmdt.sisapembayaran < 100000000) {
      //     this.label.vanumber = 'Nomor Virtual Account';
      //   } else {
      //     this.label.vanumber = 'Nomor Account';
      //     this.frmdt.vanumber = '526-0905637'
      //     this.frmdt.namabank = 'BCA - PT MURNI ALDANA MANAJEMEN'

      //   }
      // }

      //console.log("#1 this.frmdt.ttlangsuran: ", this.frmdt.ttlangsuran);
      //console.log("#this.frmdt 2: ", this.frmdt);
    },
    resetCalc() {
      this.frmdt.uraian = "";
      this.frmdt.ttlinstalmentcurrent = 0;
      this.frmdt.ttlprincipalcurrent = 0;
      this.frmdt.ttllatechargecurrent = 0;
      this.frmdt.ttlinterestcurrent = 0;
      this.frmdt.ttlinstalment = 0;
      this.frmdt.ttlprincipal = 0;
      this.frmdt.ttllatecharge = 0;
      this.frmdt.ttlinterest = 0;
      this.frmdt.ttlangsuran = 0;
      this.frmdt.ospokokbelumjt = 0;
      this.frmdt.dendalain = 0;
      this.frmdt.pinalty = 0;
      this.frmdt.diskon_principal_percent = 0;
      this.frmdt.diskon_interest_percent = 0;
      this.frmdt.diskon_angsuran_percent = 0;
      this.frmdt.diskon_latecharge_percent = 0;
      this.frmdt.diskon_ospokokbelumjt_percent = 0;
      this.frmdt.diskon_dendalain_percent = 0;
      this.frmdt.diskon_pinalty_percent = 0;
      this.frmdt.diskon_principal_amount = 0;
      this.frmdt.diskon_interest_amount = 0;
      this.frmdt.diskon_angsuran_amount = 0;
      this.frmdt.diskon_latecharge_amount = 0;
      this.frmdt.diskon_ospokokbelumjt_amount = 0;
      this.frmdt.diskon_dendalain_amount = 0;
      this.frmdt.diskon_pinalty_amount = 0;
      this.frmdt.net_ttlprincipal = 0;
      this.frmdt.net_ttlinterest = 0;
      this.frmdt.net_ttlangsuran = 0;
      this.frmdt.net_ttllatecharge = 0;
      this.frmdt.net_ospokokbelumjt = 0;
      this.frmdt.net_dendalain = 0;
      this.frmdt.net_pinalty = 0;
      this.frmdt.ttlpayment = 0;
      this.frmdt.prepaid = 0;
      this.frmdt.ttlmustpay = 0;
      this.ifCalculated = false;
    },
    close() {
      router.push({ name: "loan.pelunasan" });
    },
    // testPrint(){
    //   window.print();
    // },
    async printPDFDebiturInfo() {
      try {
        if (this.invalidFrmDt) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.isLoading = true;
          this.reportUrl = await pinjaman.printPDFDebiturInfo(
            this.frmdt
          );
          this.isLoading = false;
          this.showReport = true;
        }
      } catch (error) {
        this.showReport = false;
        this.isLoading = false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    }
  },
};
</script>
